import React, { useState } from "react";
import PatientVisitRulesFilter from "../components/PatientVisitRulesFilter";
import CloseSvg from "../../../../../assets/svgs/CloseSvg";
import PatientVisitRulesTable from "../components/PatientVisitRulesTable";
import Pagination from "../../../../../components/Pagination/Pagination";

const PatientVisitRules = ({
  rules,
  handlePatientVisitRulesModal,
  constraintToEdit,
  setConstraintToEdit,
  setVisitRules,
  isWelcomePage,
  count,
  fetchConstraints,
  setSearch,
  search,
  setAvailabilityFilter,
  availabilityFilter,
}) => {
  // const [nameFilter, setNameFilter] = useState("");
  // const [AvailabilityFilter, setAvailabilityFilter] = useState([]);

  const handleNameFilter = (name) => {
    setSearch(name);
  };

  const handleAvailabilityFilter = (Availability) => {
    if (availabilityFilter.includes(Availability)) {
      setAvailabilityFilter(
        availabilityFilter.filter((filter) => filter !== Availability)
      );
    }

    if (!availabilityFilter.includes(Availability)) {
      setAvailabilityFilter([...availabilityFilter, Availability]);
    }
  };

  const handleEditClick = (constraint) => {
    if (constraintToEdit) {
      setConstraintToEdit(null);
    } else {
      setConstraintToEdit(constraint);
    }
  };

  // const filterPatientVisitRules = (rule) => {
  //   const nameMatch = rule.name
  //     .toLowerCase()
  //     .includes(nameFilter.toLowerCase());

  //   let AvailabilityMatch = false;

  //   AvailabilityFilter.forEach((day) => {
  //     if (!AvailabilityMatch) {
  //       AvailabilityMatch = rule.visitDays.includes(day.toUpperCase());
  //     }
  //   });

  //   return nameMatch && (AvailabilityFilter.length === 0 || AvailabilityMatch);
  // };

  return (
    <>
      <div
        className={`max-h-screen ${isWelcomePage ? " py-2" : "p-4 "
          } overflow-hidden`}
      >
        <div className="flex  w-full gap-2 mb-4">
          <div className="flex flex-row items-center justify-between">
            <div className="m-0 text-lg font-bold w-44">
              {count} record
              {count > 1 && "s"}
            </div>
          </div>
          <PatientVisitRulesFilter
            handleNameFilter={handleNameFilter}
            handleAvailabilityFilter={handleAvailabilityFilter}
            nameFilter={search}
            AvailabilityFilter={availabilityFilter}
            isWelcomePage={isWelcomePage}
          />
        </div>
        <div className="w-full px-16">
          <Pagination count={count} api={fetchConstraints} />
        </div>
        <PatientVisitRulesTable
          rules={rules}
          handleEditClick={handleEditClick}
          setVisitRules={setVisitRules}
          isWelcomePage={isWelcomePage}

        />
      </div>
    </>
  );
};

export default PatientVisitRules;
